import type { Translatable } from "app/pages/sales-intelligence/types";

import SelectionItem from "../SelectionItem";

import type { TopNDropdownItemDeps } from "./types";

export default class TopNDropdownItem extends SelectionItem {
    constructor({ alias, id, value, disabledReason }: TopNDropdownItemDeps) {
        super(alias ?? `top-${value}`, id, value, disabledReason);
    }

    getSelectedTranslation(): Readonly<Translatable> {
        return this.getTranslation();
    }

    getTranslation(): Readonly<Translatable> {
        return {
            key: `si.${this.translationKeyModifier}.options.top-n`,
            replacements: {
                n: this.formatValue(),
            },
        };
    }
}
